// ----------------------------------------------------------------------------
// Скролл к сообщению
// ----------------------------------------------------------------------------



const ttLKScrollToMessage = (isOk) => {
    const target = document.querySelector('.g-message');

    if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        document.addEventListener('scrollend', () => {
            document.dispatchEvent(new Event('scroll'));
        }, { once: true });



        if (isOk === 1) {
            setTimeout(() => {
                target.classList.add('tt-animation-hide');

                setTimeout(() => {
                    target.style.display = 'none';
                }, 300);
            }, 4000);
        }
    }
}

export default ttLKScrollToMessage;
